module.exports = __webpack_public_path__ + "static/app-store_135x40-1cfd5dba4a9210bcf77f5dbe48ec2e66.svg";